<script lang="ts">
  import { onMount } from 'svelte';
  import { auth } from '$lib/stores/auth';

  let factorId = '';
  let code = '';
  let ready = false;

  onMount(async () => {
    const factors = await auth.listFactors();
    const verified = factors.find((f) => f.status === 'verified');
    if (verified) factorId = verified.id;
    ready = true;
  });

  async function verify() {
    if (!factorId) return;
    await auth.verifyTotp(factorId, code);
    // On success the store's mfaRequired flips to false and this gate unmounts.
    code = '';
  }
</script>

<div class="mfa-container">
  <h2>Two-factor authentication</h2>
  <p class="info">Enter the 6-digit code from your authenticator app.</p>

  {#if $auth.error}
    <p class="error">{$auth.error}</p>
  {/if}

  {#if ready && !factorId}
    <p class="error">No verified authenticator found for this account.</p>
  {:else}
    <div class="fields">
      <input
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="6"
        bind:value={code}
        placeholder="123456"
      />
      <button on:click={verify} disabled={$auth.loading || code.length < 6}>Verify</button>
    </div>
  {/if}

  <button class="link" on:click={() => auth.signOut()}>Sign out</button>
</div>

<style>
  .mfa-container {
    max-width: 400px;
    margin: 2rem auto;
    padding: 2rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    text-align: center;
  }

  .fields {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin: 1rem 0;
  }

  input {
    padding: 0.75rem 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1.25rem;
    text-align: center;
    letter-spacing: 0.3em;
  }

  button {
    padding: 0.75rem 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    font-size: 1rem;
  }

  button:hover {
    background: #f5f5f5;
  }

  .error {
    color: #d32f2f;
  }

  .info {
    color: #666;
  }

  .link {
    background: none;
    border: none;
    color: #1565c0;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
  }
</style>
